import React from "react"
import MegaMenu from "../MegaMenu"

const MegaMenuPagesSelection = ({
  name = "",
  card = [],
  megaMenuData = [],
  isMegaMenuActive,
  triggerParentUpdate,
}) => {
  const data = megaMenuData.map((item) => {
    const { route, label, description } = item.attributes
    return {
      route: route,
      label: label,
      subTitle: description,
    }
  })
  return (
    <MegaMenu
      data={data}
      name={name}
      card={card && card}
      isMegaMenuActive={isMegaMenuActive}
      triggerParentUpdate={triggerParentUpdate}
    />
  )
}

export default MegaMenuPagesSelection
